import PageHeader from 'components/PageHeader'
import React from 'react'
import AddClientData from './AddClientData'

const AddClient = () => {
  return (
    <div className="dashboard-container">
      <PageHeader title="Add Client" hideFilter hideCalendar/>
      <AddClientData />
    </div>
  )
}

export default AddClient